<template>
    <div class="loading">
        <div>
            <van-loading color="#1989fa" size="48" vertical>自动登录中，请稍候...</van-loading>
            <!-- <div>联空code:{{this.lk_code}}</div>
            <div v-if="encrypt_user">data:{{this.encrypt_user}}</div>
            <van-button type="default" size="large" @click="login()">登录测试</van-button> -->
        </div>
    </div>
</template>

<style lang="less" scoped>
    .loading {
        height: 100vh;
        text-align: center;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
    }
</style>

<script>
    import Vue from "vue";
    import {
        mapState,
        mapActions
    } from "vuex";
    import {
        Loading
    } from "vant";
    import * as user_api from "@/api/user";
    import * as lib_auth from "@/libs/auth";

    Vue.use(Loading);
    export default {
        data() {
            return {
                isLoading: true,
                lk_code: "", //用于换取token的code
                url: "",
                state: "",
                hospId: "",
                encrypt_user: null,
            };
        },
        created() {
            //把微信打乱的url地址静默修复
            var changeUrl =
                `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.hash}${window.location.search}`;
            window.history.pushState({}, 0, changeUrl);
            // this.lk_code = this.getUrlCode().code;
            // this.state = this.getUrlCode().state;
            this.lk_code = this.$route.query.auth_code;
            this.state = this.$route.query.state;
            this.hospId = this.$route.query.hospid;
            // console.log("code=" + this.lk_code);
            // console.log("state=" + this.state);

        },
        mounted() {
            setTimeout(() => {
                this.getUser();
            }, 1000);
        },
        methods: {
            ...mapActions("user", {
                setOpenId: "setOpenId"
            }),
            getUrlCode() {
                // 截取url中的code方法
                var url = window.location.search;
                this.winUrl = url;
                var theRequest = new Object();
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1);
                    var strs = str.split("&");
                    for (var i = 0; i < strs.length; i++) {
                        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                    }
                }
                return theRequest;
            },
            getUser() {
                if (!this.lk_code || this.lk_code == '') {
                    return;
                }
                user_api.ssoUser(this.hospId, this.lk_code).then(res => {
                    if (res.data) {
                        this.encrypt_user = res.data;
                        this.login();
                    }
                })
            },
            login() {
                if (!this.encrypt_user || this.encrypt_user == '') {
                    return;
                }
                user_api.ssoLogin(this.hospId, this.encrypt_user).then(loginRes => {
                    if (loginRes.user) {
                        lib_auth.setUser(loginRes.user); //将登录用户信息保存到cookie
                        if (loginRes.user.openId && loginRes.user.openId !== '')
                            _this.setOpenId(loginRes.user.openId); //保存openId到vuex store

                        this.$toast("自动登录成功");
                    }

                    this.isLoading = false;
                    var route = this.$router.options.routes.find(r => r.name == this.state);
                    if (route) {
                        this.$router.replace({
                            path: route.path,
                            query: {
                                hospid: this.hospId,
                                externalLink: 1 //表示是从外部链接跳转的,用于判断后退的逻辑
                            }
                        })
                    } else {
                        this.$router.replace({
                            path: '/',
                            query: {
                                hospid: this.hospId
                            }
                        }); //到首页
                    }
                }).catch(err => {
                    this.isLoading = false;
                    console.log(err)
                    this.$router.replace({
                        path: '/',
                        query: {
                            hospid: this.hospId
                        }
                    }); //到首页
                });
            }
        }
    };
</script>